import {XauditModel} from '../xaudit.model';

export class DataArPaymentToken extends XauditModel{

    CCPaymentTokenID: string;
    PatientId: string;
    Description: string;
    PaymentProcessorId: string;
    PayToken: string;
    isVerbalConsent: boolean;
    ConsentOn: Date;
    ConsentExparationOn: Date;

}
